import React from "react"

import { ListingCard } from "../../cards"
import { iPageExcerpt } from "../../types"
import { ContentSeparator } from "../Utils/ContentSeparator"
import { ContentHeadingView } from "./ContentHeading"

const RelatedArticle: React.FC<{ data: iPageExcerpt[] }> = ({ data }) => {
  if (!data) return null
  if (data.length === 0) return null

  return (
    <section>
      <ContentHeadingView text="Related Articles" />
      <ContentSeparator />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {data!.map((page, index) => (
          <ListingCard
            key={index}
            title={page.title}
            image={page.thumbnail.childImageSharp.fluid}
            description={""}
            link={page.link}
          />
        ))}
      </div>
      <ContentSeparator />
      <ContentSeparator />
    </section>
  )
}

export default RelatedArticle
